import { render, staticRenderFns } from "./ContactListComponent.vue?vue&type=template&id=67f310d2&scoped=true&"
import script from "./ContactListComponent.vue?vue&type=script&lang=js&"
export * from "./ContactListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContactListComponent.vue?vue&type=style&index=0&id=67f310d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f310d2",
  null
  
)

export default component.exports